import { SourceType } from 'module/api/filter/types';
import { useCompanyFieldsAsFilterableField } from 'helpers/fields/company-fields/fields';
import { accountBlockResponseToLookup } from '../../../shared/response-renderer-utils';
import { SharedDetailBlockPromptSection } from '../../shared-detail-blocks/prompt-section';
import { AccountDetailsSectionComponentProps } from '../types';

export const AccountDetailsPromptSection = ({
  node,
  onRemove,
  onDone,
  onUndo,
  onOpen,
  allowResolve,
  contentEditable,
  pageType,
}: AccountDetailsSectionComponentProps) => {
  const { fields: companyFields, loading: isLoading } =
    useCompanyFieldsAsFilterableField();

  return (
    <SharedDetailBlockPromptSection
      node={node}
      sourceType={SourceType.Company}
      useFieldsHook={() => ({ fields: companyFields, loading: isLoading })}
      defaultTitleKey="rich_text_editor_sections_account_details"
      titlePlaceholderKey="rich_text_editor_sections_account_details_title_placeholder"
      fieldLabelKey="grouped_filter.company"
      responseToLookupFunction={accountBlockResponseToLookup}
      onDone={onDone}
      onUndo={onUndo}
      onOpen={onOpen}
      onRemove={onRemove}
      contentEditable={contentEditable}
      allowResolve={allowResolve}
      pageType={pageType}
    />
  );
};
